// import type { IGetDetailResult } from "./get-detail.interface";

export enum ERarity{
    N = 'N',
    R = 'R',
    SR = 'SR',
    SSR = 'SSR'

}
export interface ICrawlOptions{
    fromPage?: number;
    maxPage?: number;
    minPrice?: number;
    maxPrice?: number;
    baseLevel?: number;
    minPower?:number;
    rarity?: ERarity; 
    sleep?: number;
  }

  export type CrawlerCallback = (foundedItem: any[]) => void

  export interface IInfoList {
    total: number;
    pageSize: number;
    currentPage: number;
    more: boolean;
  }
